import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface MilestonesState {
  holidays: any;
  employeeDates: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "milestones" | "holidays" | "sync-holidays" | null;
}

const initialState: MilestonesState = {
  holidays: null,
  employeeDates: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getHolidays: any = createAsyncThunk(
  "fetch/miscHolidays",
  async (payload: { year: number; holidayCalID?: string }, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.MISC.HOLIDAYS, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getEmployeeDates: any = createAsyncThunk(
  "fetch/employeeDates",
  async (payload: { empId: string }, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.MISC.GET_EMPLOYEE_DATES, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const syncHolidays: any = createAsyncThunk(
  "sync/holidays",
  async (payload: { year: number }, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.MISC.SYNC_HOLIDAY_LIST, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const milestonesSlice = createSlice({
  name: "milestones",
  initialState: initialState,
  reducers: {
    resetMilestones: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.holidays = null;
      state.employeeDates = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    // Holidays
    builder.addCase(getHolidays.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "holidays";
    });
    builder.addCase(getHolidays.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.holidays = action.payload;
      state.error = null;
      state.action = "holidays";
    });
    builder.addCase(getHolidays.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "holidays";
    });

    // Employee Dates
    builder.addCase(getEmployeeDates.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "milestones";
    });
    builder.addCase(getEmployeeDates.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.employeeDates = action.payload;
      state.error = null;
      state.action = "milestones";
    });
    builder.addCase(getEmployeeDates.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "milestones";
    });

    // Sync Holidays
    builder.addCase(syncHolidays.pending, (state) => {
      state.loading = "pending";
      state.error = null;
      state.action = "sync-holidays";
    });
    builder.addCase(syncHolidays.fulfilled, (state) => {
      state.loading = "fulfilled";
      state.error = null;
      state.action = "sync-holidays";
    });
    builder.addCase(syncHolidays.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.action = "sync-holidays";
    });
  },
});

export const { resetMilestones } = milestonesSlice.actions;
export default milestonesSlice.reducer;
